<div id="maxx-chat-container"></div>
